import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.992 1.317a5.75 5.75 0 0 0-4.045 1.614l-.007.007-1.72 1.71a.75.75 0 1 0 1.057 1.064l1.716-1.706a4.25 4.25 0 0 1 6.01 6.008l-2.995 2.996a4.25 4.25 0 0 1-6.41-.46.75.75 0 1 0-1.2.9 5.75 5.75 0 0 0 8.67.62l3-3 .01-.009a5.75 5.75 0 0 0-4.086-9.744M10.405 8.26a5.75 5.75 0 0 0-4.477 1.67l-3 3-.01.009a5.75 5.75 0 0 0 8.131 8.13l.01-.009 1.71-1.71a.75.75 0 0 0-1.061-1.06l-1.705 1.705a4.25 4.25 0 0 1-6.01-6.01L6.99 10.99a4.25 4.25 0 0 1 6.409.46.75.75 0 1 0 1.2-.9 5.75 5.75 0 0 0-4.193-2.29",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }